import { useRef} from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function HomeService() {
    const sliderRef = useRef(null);
        
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };
  return (
    <>
    <div className="homepage-sevice">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <div className="hometeam-head">
                        <h4 className="heading">Our Services</h4>
                        <Link to={"/services"} className="default-btn colored-btn">View All <Icons name="Longarrow_right"/></Link>
                    </div> 

                    <p className="servslider-title">The Finishing Touch to Finishing Touches</p>

                    <Slider {...settings} ref={sliderRef} className="services-slider">
                        <div>
                            <div className="servicebox">
                                <Link to={"/modular-work"}>
                                    <div>
                                        <img src="/image/landservice-1.webp" loading="lazy" className="img-responsive" alt="service"/>
                                        <small>Know More <Icons name="Longarrow_right"/></small>
                                    </div>
                                    <span>Modular Work</span>
                                    <p>We build modular setups that boost  productivity and keep your space sleek.</p>
                                </Link>
                            </div>
                        </div>

                        <div>
                            <div className="servicebox">
                                <Link to={"/millwork"}>
                                    <div>
                                        <img src="/image/landservice-3.webp" loading="lazy" className="img-responsive" alt="service"/>
                                        <small>Know More <Icons name="Longarrow_right"/></small>
                                    </div>
                                    <span>Millwork</span>
                                    <p>We craft custom woodwork that adds character, functionality, and timeless appeal to your space.</p>
                                </Link>
                            </div>
                        </div>

                        <div>
                            <div className="servicebox">
                                <Link to={"/bespoke-furniture"}>
                                    <div>
                                        <img src="/image/landservice-2.webp" loading="lazy" className="img-responsive" alt="service"/>
                                        <small>Know More <Icons name="Longarrow_right"/></small>
                                    </div>
                                    <span>Bespoke Furniture</span>
                                    <p>Handcrafted to perfection, our bespoke furniture pieces are tailored to your taste.</p>
                                </Link>
                            </div>
                        </div>

                        <div>
                            <div className="servicebox">
                                <Link to={"/turnkey-solution"}>
                                    <div>
                                        <img src="/image/landservice-4.webp" loading="lazy" className="img-responsive" alt="service"/>
                                        <small>Know More <Icons name="Longarrow_right"/></small>
                                    </div>
                                    <span>Turnkey Solutions</span>
                                    <p>We provide end-to-end project management, from design to seamless execution.</p>
                                </Link>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </div> 
    </>
  )
}
